import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M65.4 85.6C56.2 76.5 51 64 51 51s5.2-25.5 14.4-34.6C74.5 7.2 87 2 100 2s25.5 5.2 34.6 14.4C143.8 25.5 149 38 149 51s-5.2 25.5-14.4 34.6C125.5 94.8 113 100 100 100s-25.5-5.2-34.6-14.4zm34.6 30.2 15.6-15.8c42.8 6.9 76.4 41.9 81.7 85.8.8 6.7-4.7 12.2-11.5 12.2H14.3c-6.8 0-12.3-5.5-11.5-12.2C8.1 142 41.7 107 84.5 100l15.5 15.8zm-16.8 51 16.8 17 16.8-17-16.8-51-16.8 51z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}